import { app_version } from 'app/config/constants'
import { startup } from 'app/config/startup'
import 'app/css/index.scss'
import 'app/css/design/tsum/index.css'

console.info('share', app_version)
startup()
